module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.19801/js/img/splash-page/bottom-left-yolk.svg"